export interface CarCharacteristics {
  registration: string;
  registrationType: string;
  color: string;
  energy: string;
  cylinders: number;
  numberOfDoors: number;
  propulsionType: string;
  chassisNumber: string;
  modelYear: number;
  engineNumber: string;
  gearboxType: string;
  gearboxNbSpeed: number;
  gearboxNumber: string;
  unloadedWeight: number;
  horsepower: number;
  fiscalPower: number;
  kwPower: number;
  totalRollingWeight: number;
  co2Emission: number;
}
